import html from "../asset/Images/html.png";
import css from "../asset/Images/css.png";
import Js from "../asset/Images/js.png";
import React from "../asset/Images/react.png";
import figma from "../asset/Images/figma.png";
import java from "../asset/Images/java.png";
import c from "../asset/Images/c.png";
import cpp from "../asset/Images/c++.png";
import tailwind from "../asset/Images/tailwind.png";
import firebase from "../asset/Images/firebase.png";
import sass from "../asset/Images/sass.png";
import ruby from "../asset/Images/ruby.png"
import next from "../asset/Images/nextjs.svg";
import redux from "../asset/Images/redux.png";
const SkillsData =[
    {
        name:"HTML",
        details:"HTML is a Hyper Text Markup Language used of building structure of the website",
        image:html
    },
    {
        name:"CSS",
        details:"CSS is a Cascading Style Sheet used for designing the website structure",
        image:css
    },
    {
        name:"SCSS",
        details:"SCSS is a pre-processor of the css it provide additioanl functionality to css",
        image:sass
    },
    {
        name:"Tailwind CSS",
        details:"Tailwind CSS is a designing library of the css for designing the websites",
        image:tailwind
    },
    {
        name:"JavaScript",
        details:"Javascript is a programming language for adding all logics and functionalities in the website",
        image:Js
    },
    {
        name:"ReactJs",
        details:"ReactJs is a front-end library of the Javascript to build single page applications",
        image:React
    },
    {
        name:"Redux",
        details:"Redux is simply a store to store the state of the variables in your app and which can be shared by any component",
        image:redux
    },
    {
        name:"NextJs",
        details:"NextJs is a front-end framework of the Javascipt it provide additional functionallity to ReactJs",
        image:next
    },
    {
        name:"Firebase",
        details:"Firebse is google backend tool which provides database,authentication services to the developer",
        image:firebase
    },
    {
        name:"Java",
        details:"Java is a programming language used in building platform-independent application development",
        image:java
    },
    {
        name:"C",
        details:"C language is high level language used for doing low level task with low level memory maipulation features",
        image:c
    },
    {
        name:"C++",
        details:"C++ is a extention of C language it is widely used for building O.S,games,performance-critical applications",
        image:cpp
    },
    {
        name:"Ruby",
        details:"Ruby is a high level language widely used for building web development,scripting,data analysis",
        image:ruby
    },
    {
        name:"Figma",
        details:"Figma is designing tool used for creating any application or software design and other creative designing task",
        image:figma
    }
]

export default SkillsData;